import React, { useEffect } from "react";
import { SlideDown } from "react-slidedown";
import useNewReportStyles from "./newReport.style"
import axios from 'axios';
import moment from "moment-timezone"
import 'react-slidedown/lib/slidedown.css'
import { get_preview } from "../../config/apiUrls"
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';


export const ISO_DATE_FORMAT = "MM/DD/YYYY";
export const EASTERN_TIMEZONE = "America/New_York";

const formatdate = date => {
    return moment(date).format(ISO_DATE_FORMAT);
}

const PreviewResults = props => {
    const { showPreview, year, week, onClose, data } = props;
    const classes = useNewReportStyles();

    return (
        <div className={"dropdown-container"} style={{ minWidth: 700, marginLeft: "2rem" }}>
            {/* <SlideDown> */}

            <div>
                <div className={classes.titleHead} style={{ marginLeft: 15 }}><div>Preview Result</div>

                    {/* <IconButton classes={{ root: classes.closeButton }} onClick={onClose}>
                    <CloseIcon />
                </IconButton> */}
                </div>
                {showPreview && <PreviewContent items={data} />}
            </div>

            {/* </SlideDown> */}
        </div>
    );
}

const PreviewContent = (props) => {
    // const [items, setData] = React.useState(null)
    const { items } = props;
    const classes = useNewReportStyles();

    return (
        <div style={{ marginTop: 10 }}>
            {
                items && items.map(data => (
                    <div className={classes.text}>
                        <div>
                            <span className={classes.date}>Dates  :</span>
                            {formatdate(data.firstDay)} - {formatdate(data.lastDay)}
                        </div>
                        <div style={{ marginTop: 10 }}>
                            <div style={{ display: "flex", maxHeight: "calc(100vh - 250px)", overflow: "auto", border: "1px solid #777" }}>
                                {
                                    data ?.groups.length > 0 ? data.groups.map(head =>
                                        <>

                                            <div>
                                                <div className={classes.previewTableHeaderCell}>{head.group}</div>
                                                {
                                                    head.matchup.map(row => <div className={classes.previewTableCell}>{row}</div>)
                                                }
                                            </div>
                                        </>
                                    ) :
                                        <div>No Data Available</div>
                                }
                            </div>
                        </div>
                    </div>
                ))
            }
        </div>
    )
}

export default PreviewResults;